import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Header } from 'src/app/models/header.model';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'cc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() info: Header;
  @Output() iconClicked = new EventEmitter<any>();
  @Output() secondIconClicked = new EventEmitter<any>();

  public iconColor: string = 'dark'

  constructor(
    private utils: UtilsService,
    private platform: Platform
  ) { }

  ngOnInit() {
    this.iconColor = this.platform.is('ios') ? 'primary' : 'dark';
  }

  openMenu() {
    this.utils.openMenu();
  }

}
